module.exports = __webpack_public_path__ + "static/media/TN-Women-DressShoes-2.0_OptionAll.5153076c.svg";